import $ from "jquery";

const accordion = () => {
    $(".js-accordion-trigger").on("click", function (e) {
        e.preventDefault();

        const $currentContent = $(this).next(".js-accordion-content");
        const $currentArrow = $(this).find(".js-accordion-arrow");
        const $currentParent = $(this).parent(".js-accordion-item");

        // Slide up all content except the one that's about to toggle
        $(".js-accordion-content").not($currentContent).slideUp();

        // Remove 'active' class from all arrows except the current one
        $(".js-accordion-arrow").not($currentArrow).removeClass("active");

        // Toggle the current content and the 'active' class on the arrow
        $currentContent.slideToggle();
        $currentArrow.toggleClass("active");

        if ($currentParent.length > 0) {
            $currentParent.toggleClass("active");
        }
    });
};

export default accordion;
